import Framework from 'framework';

const actionAllowed = 'Allowed';
const actionErrored = 'Errored';
const actionRefused = 'Refused';
const actionRequested = 'Requested';
const lst = {
	init: function () {
		lst.userLocation = {
			coords: null,
			browserLocationSettings: {error: null, prompted: false}
		};
		lst.gettingCurrentPosition = false;
		lst.getCurrentPositionTimeout = 1000;
		lst.getLocation();
	}, getLocation: function () {
		if(navigator.geolocation) {
			lst.gettingCurrentPosition = true;
			lst.trackPopupShowing();
			// do a call for tracking purposes as the only way to track exactly 'Requested' action -
			// show of asking popup to share location
			navigator.geolocation.getCurrentPosition(lst.setPosition, lst.handleError);
		}else{
			lst.doDataLayerPush(actionErrored, 'unsupported by browser');
		}
	}, trackPopupShowing: function () {
		window.setTimeout(function () {
			lst.gettingCurrentPosition = false;
			// if neither coordinates nor error are set - browser location popup is shown
			if(!(lst.userLocation.coords || lst.userLocation.browserLocationSettings.error)) {
				lst.doDataLayerPush(actionRequested, '');
				lst.userLocation.browserLocationSettings.prompted = true;
			}
		}, lst.getCurrentPositionTimeout);
	}, setPosition: function (position) {
		lst.userLocation.coords = position.coords;
		if(lst.gettingCurrentPosition) {
			// if callback executed before setting gettingCurrentPosition = false
			// - consider it as allowed automatically
			lst.userLocation.browserLocationSettings.prompted = false;
			lst.gettingCurrentPosition = false;
		}else{
			// else allowed by user
			lst.userLocation.browserLocationSettings.prompted = true;
			lst.doDataLayerPush(actionAllowed, '');
		}
	}, handleError: function (positionError) {
		lst.gettingCurrentPosition = false;
		let action = actionErrored;
		switch(positionError.code) {
			case positionError.PERMISSION_DENIED:
				lst.userLocation.browserLocationSettings.error = 'blocked by user';
				action = actionRefused;
				break;
			case positionError.POSITION_UNAVAILABLE:
				lst.userLocation.browserLocationSettings.error = 'position unavailable';
				break;
			case positionError.TIMEOUT:
				lst.userLocation.browserLocationSettings.error = 'request timed out';
				break;
			default:
				lst.userLocation.browserLocationSettings.error = 'unknown error';
		}
		// don't push event when there was no attempt to prompt the user to share location
		// - blocked by default or blocked previously
		if(!(action === actionRefused && !lst.userLocation.browserLocationSettings.prompted)) {
			lst.doDataLayerPush(action, lst.userLocation.browserLocationSettings.error);
		}
	}, doDataLayerPush: function (action, errorMessage) {
		Framework.actions.collectAnalytics({
			event: 'Location Sharing ' + action,
			locationSharing: {locationRequestAction: action, locationRequestErrorMessage: errorMessage}
		});
	}
};

export default lst.init;
